import React, { Component } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';
import ReactTable from 'react-table';

import { Well } from 'react-bootstrap';

import { ILoan, ILoanPayment } from '../../../interfaces';

import { loanPaymentColumns } from './Columns';

const DEFAULT_SORTED = [{ desc: true, id: 'payment_date' }];

interface IProps {
  // Only to name the loans each payment was applied to; the loans have their own tab
  loans: ILoan[];
  newButton: React.ReactNode;
  payments: ILoanPayment[];
}

@autoBindMethods
@observer
class LoanPaymentsTable extends Component<IProps> {
  // Rebuilt only when the loans themselves change, not on every render: the parent hands down the
  // same array until they do, and mobx-react only invalidates props it finds not shallow-equal.
  // Built inline instead, react-table would get a new columns identity, and the loan lookup would be
  // redone, every time anything above this re-rendered.
  @computed
  private get columns () {
    return loanPaymentColumns(this.props.loans);
  }

  private renderTable () {
    const { payments } = this.props;

    if (!payments.length) {
      return <div className='empty'>No payments have been logged against this account's loans.</div>;
    }

    return (
      <ReactTable
        columns={this.columns}
        data={payments}
        defaultSorted={DEFAULT_SORTED}
        keyField='id'
        minRows={0}
        pageSize={payments.length}
        resizable={false}
        showPagination={false}
        sortable
      />
    );
  }

  public render () {
    return (
      <Well className='loan-payments-list well-table'>
        <h3 className='flex-between'>
          Payments
          {this.props.newButton}
        </h3>
        {this.renderTable()}
      </Well>
    );
  }
}

export default LoanPaymentsTable;
